import { useTranslations } from 'next-intl';

import { styles } from './TitleGroup.styles';

export interface TitleGroupProps {
  id?: string;
  type: 'gift' | 'unavailable';
  count?: number;
  onClearAll?: () => void;
  isSupCount?: boolean;
}

export function TitleGroup({
  id,
  type,
  count,
  onClearAll,
  isSupCount = true
}: TitleGroupProps) {
  const slots = styles();
  const t = useTranslations();

  const titles: Record<TitleGroupProps['type'], string> = {
    gift: t('Your gifts'),
    unavailable: t('Out of stock')
  };
  return (
    <div
      className={`${slots.base()} ${!isSupCount && slots.baseWithNoSup()}`}
      id={id}
    >
      <div className={slots.title()}>
        {titles[type]}
        {isSupCount && <sup>{count}</sup>}
      </div>
      {!isSupCount && (
        <div className={slots.countText()}>
          {count} {t('product.inStock.units')}
        </div>
      )}
      <button
        type="button"
        className={`${slots.actionButton()} ${slots.buttonWithNoSup()}`}
        onClick={onClearAll}
      >
        {t('action-all-delete')}
      </button>
    </div>
  );
}
